"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.function.name");
var _EnrollTablePane = _interopRequireDefault(require("./EnrollTablePane.vue"));
var _EnrollConfig = _interopRequireDefault(require("./EnrollConfig.vue"));
var _EnrollJoinPane = _interopRequireDefault(require("./EnrollJoinPane.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'EnrollIndex',
  components: {
    EnrollTablePane: _EnrollTablePane.default,
    EnrollConfigPane: _EnrollConfig.default,
    EnrollJoinPane: _EnrollJoinPane.default
  },
  data: function data() {
    return {
      activeName: 'enroll_table',
      currentId: null,
      isEdit: false,
      showConfigTab: false,
      configKey: 0,
      joinTabs: []
    };
  },
  methods: {
    handleClick: function handleClick(tab) {
      this.activeName = tab.name;
    },
    handleTabRemove: function handleTabRemove(targetName) {
      if (targetName === 'enroll_config') {
        this.showConfigTab = false;
        this.activeName = 'enroll_table';
        this.currentId = null;
        this.isEdit = false;
        return;
      }
      // 关闭报名明细 Tab
      var joinIdx = this.joinTabs.findIndex(function (t) {
        return t.name === targetName;
      });
      if (joinIdx > -1) {
        this.joinTabs.splice(joinIdx, 1);
        if (this.activeName === targetName) this.activeName = 'enroll_table';
      }
    },
    handleToEnrollConfig: function handleToEnrollConfig(id) {
      var _this = this;
      this.currentId = id;
      this.isEdit = !!id;
      this.showConfigTab = true;
      this.configKey++;
      this.$nextTick(function () {
        _this.activeName = 'enroll_config';
      });
    },
    handleToEnrollJoin: function handleToEnrollJoin(payload) {
      var _this2 = this;
      var id = payload.id,
        title = payload.title,
        filters = payload.filters;
      var existing = this.joinTabs.find(function (t) {
        return t.activityId === id;
      });
      if (existing) {
        this.activeName = existing.name;
        if (filters) {
          this.$nextTick(function () {
            var ref = _this2.$refs[existing.name];
            var pane = Array.isArray(ref) ? ref[0] : ref;
            if (pane) pane.applyFilters(filters);
          });
        }
        return;
      }
      var name = "enroll_join_".concat(id);
      this.joinTabs.push({
        name: name,
        title: "\u62A5\u540D\u660E\u7EC6 - ".concat(title),
        activityId: id,
        activityTitle: title,
        filters: filters || null
      });
      this.activeName = name;
    },
    handleSuccess: function handleSuccess() {
      this.showConfigTab = false;
      this.activeName = 'enroll_table';
      this.currentId = null;
      this.isEdit = false;
      this.$refs.enroll_table.fetchData();
    },
    handleCancel: function handleCancel() {
      this.showConfigTab = false;
      this.activeName = 'enroll_table';
    }
  }
};